import React from 'react';
import { Link } from 'react-router-dom';
import departmentService from '../../services/departmentService';
import './DepartmentCard.css';

const DepartmentCard = ({ department, onDelete }) => {
  const budgetUtilization = departmentService.calculateBudgetUtilization(
    department.budget_allocated,
    department.budget_spent
  );
  const budgetStatus = departmentService.getBudgetStatus(budgetUtilization);
  const budgetStatusColor = departmentService.getBudgetStatusColor(budgetUtilization);

  // const handleDelete = () => {
  //   if (window.confirm(`Are you sure you want to delete "${department.name}"?`)) {
  //     onDelete(department.id);
  //   }
  // };

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDelete(department.id);
  };

  const teamSize = department.employees?.length || 0;
  const subDepartmentsCount = department.sub_departments?.length || 0;

  return (
    <div className="department-card">
      <div className="flex items-start justify-between p-5 border-b border-gray-200">
        <div>
          <h3 className="text-lg font-semibold text-gray-800">
            <Link
              to={`/app/departments/${department.id}`}
              className="hover:text-blue-600 transition-colors"
            >
              {department.name}
            </Link>
          </h3>

          {department.code && (
            <span className="inline-block mt-2 px-2 py-1 text-xs font-medium text-gray-600 bg-gray-100 rounded">
              {department.code}
            </span>
          )}
        </div>

        <span
          className={`badge ${department.is_active
              ? "badge-success"
              : "badge-secondary"
            }`}>
          {department.is_active ? "Active" : "Inactive"}
        </span>
      </div>

      <div className="department-card-body">
        {department.description && (
          <p className="department-description">{department.description}</p>
        )}

        <div className="department-meta">
          {department.manager && (
            <div className="meta-item">
              <i className="fas fa-user-tie"></i>
              <span>
                Manager: {department.manager.first_name} {department.manager.last_name}
              </span>
            </div>
          )}

          {department.parent_department && (
            <div className="meta-item">
              <i className="fas fa-sitemap"></i>
              <span>Parent: {department.parent_department.name}</span>
            </div>
          )}

          <div className="meta-item">
            <i className="fas fa-users"></i>
            <span>{teamSize} Team Member{teamSize !== 1 ? 's' : ''}</span>
          </div>

          <div className="meta-item">
            <i className="fas fa-building"></i>
            <span>{subDepartmentsCount} Sub-Department{subDepartmentsCount !== 1 ? 's' : ''}</span>
          </div>
        </div>

        {department.budget_allocated > 0 && (
          <div className="department-budget">
            <div className="budget-header">
              <span className="budget-label">Budget Utilization</span>
              <span className="budget-percentage" style={{ color: budgetStatusColor }}>
                {budgetUtilization}%
              </span>
            </div>
            <div className="budget-bar">
              <div
                className={`budget-fill budget-${budgetStatus}`}
                style={{ width: `${Math.min(budgetUtilization, 100)}%` }}
              ></div>
            </div>
            <div className="budget-details">
              <div className="budget-item">
                <span className="budget-label">Allocated</span>
                <span className="budget-value">
                  {departmentService.formatBudget(department.budget_allocated)}
                </span>
              </div>
              <div className="budget-item">
                <span className="budget-label">Spent</span>
                <span className="budget-value">
                  {departmentService.formatBudget(department.budget_spent)}
                </span>
              </div>
              <div className="budget-item">
                <span className="budget-label">Remaining</span>
                <span className="budget-value">
                  {departmentService.formatBudget(
                    department.budget_allocated - department.budget_spent
                  )}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="department-card-footer">
        <Link to={`/app/departments/${department.id}`} className="btn btn-sm btn-outline-primary">
          <i className="fas fa-eye"></i> View
        </Link>
        <Link to={`/app/departments/${department.id}/edit`} className="btn btn-sm btn-outline-primary">
          <i className="fas fa-edit"></i> Edit
        </Link>
        <button onClick={handleDelete} className="btn btn-sm btn-outline-danger">
          <i className="fas fa-trash"></i> Delete
        </button>
      </div>
    </div>
  );
};

export default DepartmentCard;

